import { render, staticRenderFns } from "./nextTournament.vue?vue&type=template&id=16811a2d&scoped=true"
import script from "./nextTournament.vue?vue&type=script&lang=js"
export * from "./nextTournament.vue?vue&type=script&lang=js"
import style0 from "./nextTournament.vue?vue&type=style&index=0&id=16811a2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16811a2d",
  null
  
)

export default component.exports